import React, { useState, useEffect } from 'react';
import Login from './Login';
import Dashboard from './Dashboard';

const App = () => {
  const [userEmail, setUserEmail] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const savedEmail = localStorage.getItem('userEmail');
    if (savedEmail) {
      setUserEmail(savedEmail);
    }
    setLoading(false);
  }, []);

  const handleLogin = (email) => {
    setUserEmail(email);
    localStorage.setItem('userEmail', email);
  };

  const handleLogout = () => {
    setUserEmail(null);
    localStorage.removeItem('userEmail');
  };

  if (loading) {
    return null;
  }

  return (
    <>
      {userEmail ? (
        <Dashboard userEmail={userEmail} onLogout={handleLogout} />
      ) : (
        <Login onLogin={handleLogin} />
      )}
    </>
  );
};

export default App;
